module.exports = __webpack_public_path__ + "img/point2.d5673928.png";